// modules分成不同功能的模块
import * as types from './../mutation-types.js';
import Vue from 'vue'
var target = this
const state = {
    worksheetList: []
}



const getters = {
    worksheetList: state => state.worksheetList
}

const mutations = {
    [types.GET_WORKSHEETLIST](state, res) {
    const tempArry = {
      pendingProcess: [],
      pendingReview: [],
      processing: [],
      all: [],
      ticketTypes: [],
      idcLine: []
    };
    for (const key in res) {
      if (key === "ticketTypes") {
        res[key].forEach(value => {
          tempArry[key].push({
            text: value.ticketTypeName,
            value: value.ticketTypeId
          });
        });
      } else {
        for (const keys in res[key]) {
          tempArry[key].push({
            text: res[key][keys],
            value: keys
          });
        }
      }
    }
        state.worksheetList = tempArry
    }
}

export default {
    state,
    getters,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/worksheetMap.js